import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ParcelhistoryService } from '../../../@core/services/parcelhistory.service';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { PhotoService } from '../../../@core/services/photo.service';
import { SignatureService } from '../../../@core/services/signature.service';

@Component({
  selector: 'ngx-signature-dialog',
  templateUrl: './signature-dialog.component.html',
  styleUrls: ['./signature-dialog.component.scss']
})
export class SignatureDialogComponent implements OnInit, OnDestroy {
  public parcelId: string;
  public loading: boolean = false;
  public sub: Subscription;
  public sigID: any;

  constructor(
    public dialogRef: MatDialogRef<SignatureDialogComponent>,
    public _photoService: PhotoService,
    public _signatureService: SignatureService,
    public translateService: TranslateService,
    public _parcelhistoryService: ParcelhistoryService,
    public toastservice: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  openInNewTab(url) {
    var win = window.open(url, '_blank');
    win.focus();
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
  public close(): void {
    this._photoService.clearPhotos();
    this.dialogRef.close(false);
  }

  ngOnInit(): void {
    this.parcelId = this.data.parcelId;
    this._photoService.clearPhotos();
  }
}
